export const FACEBOOK_OVERVIEW_SINGLE_BRAND = [
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 0,
    y: 0,
    meta: {
      brand_ids: ['{brandId0}'],
      channels: ['FACEBOOK'],
      metrics: ['TOTAL_FOLLOWERS'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'TOTAL',
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 1,
    y: 0,
    meta: {
      brand_ids: ['{brandId0}'],
      channels: ['FACEBOOK'],
      metrics: ['NET_NEW_FOLLOWERS'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'TOTAL',
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 2,
    y: 0,
    meta: {
      brand_ids: ['{brandId0}'],
      channels: ['FACEBOOK'],
      metrics: ['FOLLOWER_GROWTH_RATE'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'TOTAL',
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 3,
    y: 0,
    meta: {
      brand_ids: ['{brandId0}'],
      channels: ['FACEBOOK'],
      metrics: ['AVG_ENGAGEMENT_RATE_V2'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'TOTAL',
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 4,
    y: 0,
    meta: {
      brand_ids: ['{brandId0}'],
      channels: ['FACEBOOK'],
      metrics: ['AVG_EFFECTIVENESS_V2'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'TOTAL',
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 5,
    y: 0,
    meta: {
      brand_ids: ['{brandId0}'],
      channels: ['FACEBOOK'],
      metrics: ['AVG_REACH'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'TOTAL',
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 0,
    y: 2,
    meta: {
      brand_ids: ['{brandId0}'],
      channels: ['FACEBOOK'],
      metrics: ['ORGANIC_VIDEO_VIEWS'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'TOTAL',
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 1,
    y: 2,
    meta: {
      brand_ids: ['{brandId0}'],
      channels: ['FACEBOOK'],
      metrics: ['REACTIONS'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'TOTAL',
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 2,
    y: 2,
    meta: {
      brand_ids: ['{brandId0}'],
      channels: ['FACEBOOK'],
      metrics: ['ORGANIC_COMMENTS'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'TOTAL',
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 3,
    y: 2,
    meta: {
      brand_ids: ['{brandId0}'],
      channels: ['FACEBOOK'],
      metrics: ['SHARES'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'TOTAL',
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 4,
    y: 2,
    meta: {
      brand_ids: ['{brandId0}'],
      channels: ['FACEBOOK'],
      metrics: ['LINK_CLICKS'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'TOTAL',
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 5,
    y: 2,
    meta: {
      brand_ids: ['{brandId0}'],
      channels: ['FACEBOOK'],
      metrics: ['PAGE_VIEWS_PAID_AND_ORGANIC'],
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'TOTAL',
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 0,
    y: 4,
    meta: {
      brand_ids: ['{brandId0}'],
      channels: ['FACEBOOK'],
      metric: 'NET_NEW_FOLLOWERS',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 3,
    y: 4,
    meta: {
      brand_ids: ['{brandId0}'],
      channels: ['FACEBOOK'],
      metric: 'AVG_ENGAGEMENT_RATE_V2',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 0,
    y: 8,
    meta: {
      brand_ids: ['{brandId0}'],
      channels: ['FACEBOOK'],
      metric: 'ORGANIC_VIDEO_VIEWS',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 3,
    y: 8,
    meta: {
      brand_ids: ['{brandId0}'],
      channels: ['FACEBOOK'],
      metric: 'PAGE_VIEWS_PAID_AND_ORGANIC',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 1,
    type: 'HEADER',
    w: 6,
    x: 0,
    y: 12,
    meta: {
      name: 'Post Performance',
    },
  },
  {
    h: 4,
    type: 'CONTENT',
    w: 6,
    x: 0,
    y: 13,
    meta: {
      brand_ids: ['{brandId0}'],
      channel: 'FACEBOOK',
      metric: 'ENGAGEMENT_RATE_V2',
      sort_order: 'DESC',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'CONTENT',
    w: 6,
    x: 0,
    y: 17,
    meta: {
      brand_ids: ['{brandId0}'],
      channel: 'FACEBOOK',
      metric: 'VIDEO_VIEWS',
      sort_order: 'DESC',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'CONTENT',
    w: 6,
    x: 0,
    y: 21,
    meta: {
      brand_ids: ['{brandId0}'],
      channel: 'FACEBOOK',
      metric: 'ENGAGEMENT_RATE_V2',
      sort_order: 'ASC',
      content_tag_ids: ['content_tag_ids'],
    },
  },
];
